module.exports = __webpack_public_path__ + "static/media/sMode.28d992fb.png";